<button tabindex="-1" *ngIf="!isLinkButton" [matTooltip]="tooltipText" [disabled]="isDisabled"  [class]="className"
  (click)="onClickEvent($event)">
  <div *ngIf="!isLoading" [class]="iconClassName" [ngClass]="isDisabled? 'icon-disabled' : '' "></div>
  <itb-spinner *ngIf="isLoading" [spinnerType]="(className === 'round-btn-dark') ? 'm white' : 'm'" ></itb-spinner>
</button>

<a *ngIf="isLinkButton" routerLink="{{link}}"><button tabindex="-1" [matTooltip]="tooltipText" [disabled]="isDisabled"  [class]="className"
  (click)="onClickEvent($event)">
  <div *ngIf="!isLoading" [class]="iconClassName" [ngClass]="isDisabled? 'icon-disabled' : '' "></div>
  <itb-spinner *ngIf="isLoading" [spinnerType]="(className === 'round-btn-dark') ? 'm white' : 'm'" ></itb-spinner>
</button></a>